import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./pending.module.scss";

const Pending = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation();

  return (
    <Pill
      styleName="pending"
      Lefticon={<img src="../../../assets/images/svg/approval.svg" />}>
      <p className={classNames(styles.stockText, "p2")}>
        {t("lbl_waiting_for_approval_title")}
      </p>
    </Pill>
  );
};

export default Pending;
